import { useEffect, useState } from 'react';
import React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import {
    EditRequest,
    searchByRequest,
} from '../../../features/agent/AgentRequestSlice';
import Loading from '../../../Loading';
import Header from '../../dashboard/Header';
import Broadcast from '../../dashboard/Broadcast';
import { ToastContainer, toast } from 'react-toastify';
import { Calendar } from "react-multi-date-picker";
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import gregorian from "react-date-object/calendars/gregorian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian_en from "react-date-object/locales/gregorian_en"
import persian_en from "react-date-object/locales/persian_en"
import Button from '../../../component/form/Button';
import Input from '../../../component/form/Input';
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import axios from 'axios';
import { host } from '../../../function/api'
import * as Icon from 'react-feather';
import $ from 'jquery'
import { saveAs } from 'file-saver';
import * as moment from 'jalali-moment';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css' 





function Index() {
    const columns = [
        {
            name: '#',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.id} </div>,

        },
        {

            name: 'شماره سند',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.mt_sanadno}</div>
        },
        {
            name: 'شماره پلاک',
            sortable: true,
            cell: row => row.mt_pelakserial == "" ? (<span></span>) : (
                <div className="rk-pelak-back"><span>{row.mt_pelakserial}</span><span>{row.mt_pelakno}</span></div>),
        },
        {
            name: 'شماره بدنه',
            sortable: true,
            cell: row => <div className="rahpardaznet-border font-en">{row.mt_bodyno}</div>
        },
        {
            name: 'شماره موتور',
            sortable: true,
            cell: row => <div className="rahpardaznet-border font-en">{row.mt_motorno}</div>
        },
        {
            name: 'نام خریدار',
            sortable: true,
            cell: row => <div className="rahpardaznet-border">{row.buyer_name}</div>
        },
        {
            name: 'تاریخ ثبت',
            sortable: true,
            cell: row => <div className="rahpardaznet-border">{moment(row.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'عملیات',
            cell: row => <div className='rahpardaznet-agent-table-btn d-felx'>
                <button type="button" id={row.id} onClick={(e) => documentStatusUpdateHandler(row.id)}>پیوست ها</button>

                <Link  to={'/agent/request/edit/'+row.id}>ویرایش</Link>
            </div>
        },


    ];

    const dispatch = useDispatch()
    const [status, setStatus] = useState(true)
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const [RahpardaznetMobile, setًRahpardaznetMobile] = useState('');
    const [RahpardaznetCode, setRahpardaznetCode] = useState('');
    const [RahpardaznetHash, setRahpardaznetHash] = useState('');
    const [RahpardaznetValidationStatus, setRahpardaznetValidationStatus] = useState('');
    const [BtnSms, setBtnSms] = useState('');
    const [RahpardaznetStatus, setRahpardaznetStatus] = useState('');
    const [RahpardaznetId, setRahpardaznetId] = useState('');
    const [RahpardaznetFilterAgentName, setRahpardaznetFilterAgentName] = useState('');
    const [RahpardaznetFilterType, setRahpardaznetFilterType] = useState('1');
    const [start_date, setStart_date] = useState({})
    const [end_date, setEnd_date] = useState({})
    const [RahpardaznetMessage, setRahpardaznetMessage] = useState('')
    const [RahpardaznetRequestID, setRahpardaznetRequestID] = useState('')
    const [RahpardaznetStatusID, setRahpardaznetStatusID] = useState('')
    const [RahpardaznetDetailsData, setRahpardaznetDetailsData] = useState({})
    const [RahpardaznetDetailsFiles, setRahpardaznetDetailsFiles] = useState({})
    const [fake_date, setFake_date] = useState({})
    const {
        documents,
        message,
        loading,
        update,
        errorNumber,
        errorNumberType
    } = useSelector(state => state.document)
    const {
        agents,
    } = useSelector(state => state.agentRequest)
    const [number, setNumber] = useState()
    const [numberType, setNumberType] = useState()
    const [RahpardaznetLoading, setRahpardaznetLoading] = useState()
    const [RahpardaznetRandomString, setRahpardaznetRandomString] = useState()
    const ExpandedComponent = ({ data }) => (
        <>
            <div className='row text-end p-2'>
                <div className='col-12'>
                    <div className='rahpardaznet-updated-at'>
                        <label>تاریخ بروزرسانی: </label>
                        <span>{moment(data.updated_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</span>
                    </div>
                </div>
                <div className='col-12 col-md-6'>
                    <div className='rahpardaznet-details-request-item'>
                        <label>نام: </label>
                        <span>{data.customer_data.name}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>نام خانوادگی: </label>
                        <span>{data.customer_data.family}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>نام پدر: </label>
                        <span>{data.customer_data.father_name}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>محل ثبت تولد: </label>
                        <span>{data.customer_data.birthplace}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>آدرس محل سکونت: </label>
                        <span>{data.customer_data.address}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>شماره شناسنامه / ملی: </label>
                        <span>{data.customer_data.nationalCode}</span>
                    </div>

                </div>
                <div className='col-12 col-md-6'>

                    <div className='rahpardaznet-details-request-item'>
                        <label>کد پستی: </label>
                        <span>{data.customer_data.postalcode}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>تاریخ ثبت/تولد: </label>
                        <span>{data.customer_data.birthdaye}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>شماره ثبت/شناسنامه: </label>
                        <span>{data.customer_data.idcard}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>ثبت / محل صدور: </label>
                        <span>{data.customer_data.placeofissue}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>تلفن ثابت: </label>
                        <span>{data.customer_data.phone}</span>
                    </div>
                    <div className='rahpardaznet-details-request-item'>
                        <label>شماره موبایل: </label>
                        <span>{data.customer_data.mobile}</span>
                    </div>
                </div>
            </div>
        </>
    )

    
    
    const requestDeleteConfirm = (id) => {
        confirmAlert({
          title: 'آیا از حذف درخواست مطمئن هستید؟',
          message: '',
          buttons: [
            {
              label: 'حذف',
              onClick: () => requestDeleteHandler(id)
            },
            {
              label: 'لغو',
            }
          ]
        })
      };
    
    const requestDeleteHandler = async (id) => {

        const data = {
            request_id: id,
        }

      

      
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}agent/request/delete`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
        
            if (response.data.status == true) {
                toast.success(response.data.message, {
                    position: "top-center",
                    autoClose: 1200,
                })
                getRequestList();
            }
        
        } catch (error) {
            toast.error("حذف درخواست ناموفق بود.", {
                position: "top-center",
                autoClose: 1200,
            })
        }


    }

    const documentStatusUpdateHandler = async (id) => {

        const data = {
            id: id,
        }

        setRahpardaznetId(id);

        setRahpardaznetMessage(' ');
        setRahpardaznetRequestID(id);


        let r = (Math.random() + 1).toString(36).substring(7);
        $("#image-file").fileinput({
            theme: 'fa',
            uploadUrl: `${host}agent/request/upload-image`,
            uploadExtraData: function () {
                return {
                    'code': r,
                    'request_id': id,
                };
            },
            allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
            overwriteInitial: false,
            maxFileSize: 100000,
            maxFilesNum: 10
        });

        setRahpardaznetRandomString(r);

        getDocumentDetails(id);

        $('.fileinput-remove-button').trigger('click');
        $('.modalDocuments').trigger('click');

        return;
        // try {
        //     const response = await axios({
        //         method: 'POST',
        //         url: `${host}document/status/update`,
        //         data: data,
        //         headers: {
        //             'Accept': 'application/json',
        //             'Authorization': `Bearer ${localStorage.getItem('token')}`,
        //             'xsrfHeaderName': "X-XSRF-TOKEN",
        //             'withCredentials': true,
        //         }
        //     })
        //
        //     if (response.data.status == true) {
        //         toast.success(response.data.message, {
        //             position: "top-center",
        //             autoClose: 1200,
        //         })
        //         getRequestList();
        //     }
        //
        // } catch (error) {
        //     toast.error("ویرایش نا موفق بود.", {
        //         position: "top-center",
        //         autoClose: 1200,
        //     })
        // }


        // getRequestList();
    }
  

    const documentSearchHandler = (e) => {
        e.preventDefault()
        const data = {
            'number': number,
            'numberType': numberType
        }
        dispatch(searchByRequest(data));
    }

    useEffect(() => {
        if (update === true && status === true) {
            toast.success(message, {
                position: "top-center",
                autoClose: 600,
            })
            setStatus(false)
            // message = ''
        }
    }, [update])

    const [users, setUsers] = useState({});
    const [page, setPage] = useState(1);
    const countPerPage = 20;

    const getRequestList = async (search = pinCode, pageNumber = page) => {
        $('.dlUCce').addClass('loading');
        search = search == null ? "" : search;
        try {
            const response = await axios({
                method: 'GET',
                url: `${host}agent/requests?page=${pageNumber}&per_page=${countPerPage}&search=${search}&agent=${RahpardaznetFilterAgentName}&start_date=${start_date}&end_date=${end_date}&delay=1`,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            var userList = JSON.stringify(response.data);
            setUsers(response.data);
            $('.dlUCce').removeClass('loading');

        } catch (error) {
            setUsers({});
            $('.dlUCce').removeClass('loading');
        }
    };



    const getDocumentDetails = async (request_id) => {

        console.log(request_id);
        try {
            const data = {
                'request_id': request_id,
            }
            const response = await axios({
                method: 'post',
                url: `${host}agent/request/details`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            setRahpardaznetDetailsData(response.data.data);
            setRahpardaznetDetailsFiles(response.data.files);

        } catch (error) {
            toast.error("خطایی پیش آمد مجددا تلاش نمایید.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };


    function searchByDataTable(event) {
        let delayTimeOutFunction;
        delayTimeOutFunction = setTimeout(() => {
            getRequestList(event.target.value);


        }, 3000); // denounce delay

        return () => clearTimeout(delayTimeOutFunction);

    };


    const validationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        const data = {
            mobile: RahpardaznetMobile,
            code: RahpardaznetCode,
            hash: RahpardaznetHash
        }


        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/validationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.data.status) {
                toast.success("اعتبار سنجی با موفقیت انجام شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                setBtnSms('2');
                $('.close').trigger('click');


                setRahpardaznetMessage(' ');
                setRahpardaznetRequestID(RahpardaznetId);
                setRahpardaznetStatusID(RahpardaznetStatus);


                let r = (Math.random() + 1).toString(36).substring(7);
                $("#image-file").fileinput({
                    theme: 'fa',
                    uploadUrl: `${host}agent/request/upload-image`,
                    uploadExtraData: function () {
                        return {
                            'code': r,
                            'request_id': RahpardaznetId,
                        };
                    },
                    allowedFileExtensions: ['jpg', 'png', 'gif', 'jpeg', 'pdf'],
                    overwriteInitial: false,
                    maxFileSize: 2048,
                    maxFilesNum: 10
                });
                setRahpardaznetRandomString(r);

                getDocumentDetails(RahpardaznetId);

                $('.fileinput-remove-button').trigger('click');
                $('.modalDocuments').trigger('click');



            } else {
                toast.error("کد تایید نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms(' ');
            }

        } catch (error) {
            toast.error("کد تایید نا معتبر است.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms(' ');
        }


        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }


    const VerificationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        const data = {
            mobile: RahpardaznetMobile ? RahpardaznetMobile : null
        }


        setRahpardaznetHash(" ");

        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/verificationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.status == 200) {
                toast.success("پیامک با موفقیت ارسال شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })


                setBtnSms(' ');
                setRahpardaznetHash(res.data.hash);
                setRahpardaznetValidationStatus('1');
            } else {
                toast.error("پیامک ارسال نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms(' ');
            }

        } catch (error) {
            toast.error("پیامک ارسال نشد.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms(' ');
        }
        // dispatch(mobileVerificationCode(data))
        // console.log(sms_status);

    }

    const [dateObject, setDateObject] = useState(
        new DateObject()
    );

    const convert_end = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }
        setEnd_date(new DateObject(object).convert(gregorian, gregorian_en).format())
    }
    const convert_start = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }

        setStart_date(new DateObject(object).convert(gregorian, gregorian_en).format(format))

    }
    const convert_fake = (date, format = 'YYYY-MM-DD') => {
        let object = { date, format }

        setFake_date(new DateObject(object).convert(gregorian, gregorian_en).format(format))

    }



    const [pinCode, setPinCode] = useState("");
    useEffect(() => {
        getRequestList()
    }, []);

    const rahkarpardaznet_search_datatable = (e) => {
        e.preventDefault();
        setPage(1);

        $('#pagination-first-page').trigger('click');
        getRequestList(pinCode, 1);
    }
    const handlePageChange = (page) => {
        setPage(page);
        getRequestList('', page);
    };
    const RahpardaznetSubmitChangeStatus = async (e) => {
        e.preventDefault()
        const data = {
            'id': RahpardaznetId,
            'status': RahpardaznetStatus,
            'hash_code': RahpardaznetRandomString,
            'fake_date': fake_date,
            'fake_date_fa': moment(fake_date).locale('fa').format('YYYY/MM/DD HH:mm:ss')
        }

        try {
            const response = await axios({
                method: 'POST',
                url: `${host}document/status/update`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success(response.data.message, {
                    position: "top-center",
                    autoClose: 1200,
                })
                setRahpardaznetMessage(' ');
                $('.fileinput-remove-button').trigger('click');
                $('.modalDocuments').trigger('click');
                getRequestList();
            }

        } catch (error) {
            toast.error("ویرایش نا موفق بود.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };


    useEffect(() => {








    }, [])
    const RahpardaznetSubmitMessage = async (e) => {
        e.preventDefault()
        if (RahpardaznetMessage == null || RahpardaznetMessage == " ") {
            toast.error("یادداشت خالی می باشد.", {
                position: "top-center",
                autoClose: 1200,
            })
            return;
        }
        // alert(RahpardaznetMessage);
        const data = {
            'message': RahpardaznetMessage,
            'request_id': RahpardaznetRequestID,
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}agent/request/message`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })

            if (response.data.status == true) {
                toast.success('یادداشت با موفقیت ایجاد شد.', {
                    position: "top-center",
                    autoClose: 1200,
                })
                getDocumentDetails(RahpardaznetRequestID);
                $(".rahpardaznet-list-message").animate({
                    scrollTop: $('.rahpardaznet-list-message').get(0).scrollHeight
                }, 1500);
                setRahpardaznetMessage(' ');

            }

        } catch (error) {
            toast.error("یادداشت اضافه نشد.", {
                position: "top-center",
                autoClose: 1200,
            })
        }
    };

    return (
        <>


            <button type="button" className="d-none modalDocuments" data-toggle="modal" data-backdrop="static"
                data-keyboard="false" data-target="#modalDocuments"></button>

            <div className="modal modal-xl  fade" id="modalDocuments">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">پیوست های درخواست</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="row">
                                <div className='col-12 col-md-6 rahpardaznet-agent-request-list-file'>
                                    <div className='row'>
                                    {
                                        (typeof RahpardaznetDetailsFiles == 'object' && RahpardaznetDetailsFiles.length > 0) ? (
                                            <>
                                                {
                                                    RahpardaznetDetailsFiles.map((file, key) => (
                                                        <div className='col-12 col-md-6'>
                                                        <div className="rahpardaznet-request-file">
                                                            <div>{moment(file.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
                                                            <div>{file.title ? file.title : 'بدون عنوان'}</div>
                                                            <div>
                                                                <a href={"http://185.36.231.91/~rahpardaz/backend.rahpardaz.net/" + file.url} target='_blank'>دانلود فایل</a>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    ))
                                                }
                                            </>
                                        ) : (
                                            <div>پیوستی جهت نمایش وجود ندارد.</div>
                                        )
                                    }
                                    </div>
                                </div>
                             
                                <div className="col-12 col-md-6 rahpardaznet-border-right">
                                    <div className="container">
                                        <div className="rahpardaznet-list-message">

                                            {
                                                (typeof RahpardaznetDetailsData == 'object' && RahpardaznetDetailsData.length > 0) ? (
                                                    <>
                                                        {
                                                            RahpardaznetDetailsData.map((note, key) => (
                                                                <div className="message-candidate center-block">
                                                                    <div className="row rahpardaznet-message-details">
                                                                        <div className="col-xs-8 col-md-6 p-0">
                                                                            <h6 className="message-name"> {note.user_id}</h6>
                                                                        </div>
                                                                        <div className="col-xs-4 col-md-6 p-0 text-left message-date">
                                                                            {moment(note.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}
                                                                        </div>
                                                                    </div>
                                                                    <div className="row message-text">
                                                                        {note.description} ({note.description.length} کاراکتر)
                                                                    </div>
                                                                </div>
                                                            ))
                                                        }
                                                    </>
                                                ) : (
                                                    <div>یادداشتی جهت نمایش وجود ندارد.</div>
                                                )
                                            }


                                        </div>
                                    </div>
                                </div>
                                {/* <div className="col-12 border-top mt-3 pt-3 text-left">
                                    <button className="rahpardaznet-button" onClick={RahpardaznetSubmitChangeStatus}  type="button">
                                        ذخیره تغیرات
                                    </button>
                                </div> */}
                            </div>


                        </div>
                    </div>
                </div>
            </div>
            <button type="button" className="d-none modalOwnerMobile" data-toggle="modal" data-backdrop="static"
                data-keyboard="false" data-target="#modalOwnerMobile"></button>

            <div className="modal fade" id="modalOwnerMobile">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">اعتبار سنجی شماره موبایل مالک</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <input type="hidden" value={RahpardaznetHash ? RahpardaznetHash : null}
                            onChange={(e) => setRahpardaznetHash(e.target.value)} />
                        <div className="modal-body">
                            {(RahpardaznetValidationStatus == '1') ? (
                                <>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"
                                                id="inputGroup-sizing-default">کد تایید</span>
                                        </div>
                                        <input type="text" className="form-control rahpardaznet-mobile-border"
                                            aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                            value={RahpardaznetCode ? RahpardaznetCode : null}
                                            onChange={(e) => setRahpardaznetCode(e.target.value)} />
                                    </div>
                                    <div className='rahpardaznet-modal-footer'>
                                        <button type="submit" onClick={validationCodeHandler}> {BtnSms == '1' ? (
                                            <div className="spinner-border text-light"
                                                role="status"></div>) : "اعتبارسنجی"}</button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"
                                                id="inputGroup-sizing-default">شماره موبایل</span>
                                        </div>
                                        <input type="text" className="form-control rahpardaznet-mobile-border"
                                            aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                            value={RahpardaznetMobile ? RahpardaznetMobile : null}
                                            onChange={(e) => setًRahpardaznetMobile(e.target.value)} />
                                    </div>
                                    <div className='rahpardaznet-modal-footer'>
                                        <button onClick={VerificationCodeHandler}>{BtnSms == '1' ? (
                                            <div className="spinner-border text-light"
                                                role="status"></div>) : "ارسال کد"}</button>
                                    </div>
                                </>
                            )}


                        </div>
                    </div>
                </div>
            </div>
            {(loading || RahpardaznetLoading == '1') ? <Loading /> : ''}

            <Broadcast title={'درخواست های ثبت شده'} />
            
            <div className='row g-2 pr-3 pl-3 pb-4'>

                <div className="App">
                    <form onSubmit={rahkarpardaznet_search_datatable} className="rk-search-bar">
                        <input type="text" id="" placeholder='جستجو کنید'
                            value={pinCode}
                            onChange={(event) => setPinCode(event.target.value)} />
                        <button type="submit" ><Icon.Search /></button>

                    </form>
                    <DataTable
                        title=""
                        columns={columns}
                        data={users.data}
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={users.total}
                        paginationPerPage={countPerPage}
                        paginationComponentOptions={{
                            noRowsPerPage: true
                        }}
                        expandableRows
                        expandableRowExpanded={row => row.defaultExpanded}
                        expandableRowsComponent={ExpandedComponent}
                        onChangePage={handlePageChange}
                    />
                </div>


            </div>

        </>
    )
}

export default Index;